import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InventoryDetailPage } from './inventory-detail.page';
import { PagesModule } from '../../pages.module';

const routes: Routes = [
  {
    path: '',
    component: InventoryDetailPage
  }
];

@NgModule({
  imports: [
    PagesModule,
    RouterModule.forChild(routes)
  ],
  declarations: [InventoryDetailPage]
})
export class InventoryDetailPageModule { }
